###
# Модель счета
###
App.Invoice = DS.Model.extend
  bank_details            : DS.attr 'string'
  checkout_date           : DS.attr 'date'
  invoice_date            : DS.attr 'date'
  is_performed            : DS.attr 'boolean'
  number                  : DS.attr 'string'
  sum                     : DS.attr 'number'
  secure_id: DS.attr 'string'

  has_detailed_version:    DS.attr 'boolean'
  has_act:                 DS.attr 'boolean'

  # Внешние связи
  invoice_items     : DS.hasMany 'invoice_item', {async: false}
  organization      : DS.belongsTo 'organization', {async: true}
